import { AlertTriangle } from 'lucide-react'
import { t } from '@/shared/lib/i18n'
import type { LifecycleStatus } from '@/entities/lot/model/lifecycleStatus'
import { getLotsExpireAlert, type LotsExpireAlert } from '@/entities/lot/model/lotsExpireAlert'

export const lotsExpireAlertMessage = (alert: LotsExpireAlert): string => {
  switch (alert.kind) {
    case 'week':
      return t('instruments.lotsIndex.lotsExpireAlert.week')
    case 'today':
      return t('instruments.lotsIndex.lotsExpireAlert.today')
    case 'day':
      return t('instruments.lotsIndex.lotsExpireAlert.day')
    case 'days':
      return t('instruments.lotsIndex.lotsExpireAlert.days', { count: alert.count })
  }
}

type LotsExpireWarningProps = {
  expirationDate: string | null | undefined
  lifecycleStatus: LifecycleStatus | null | undefined
  timeZone: string | null | undefined
  className?: string
}

/** Legacy 7-day / week expiration warning chip (JW 407). */
export const LotsExpireWarning = ({
  expirationDate,
  lifecycleStatus,
  timeZone,
  className,
}: LotsExpireWarningProps) => {
  if (!timeZone) return null

  const alert = getLotsExpireAlert({ expirationDate, lifecycleStatus, timeZone })
  if (!alert) return null

  return (
    <span
      className={className ?? 'inline-flex items-center gap-1 text-amber-600 dark:text-amber-400'}
      data-testid="lots-expire-warning"
    >
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>{lotsExpireAlertMessage(alert)}</span>
    </span>
  )
}
